import React from "react";
import { getCurrentDateWithHour } from "./../../../utils/Utils";
import "./errorNoControlado.css";
import { useNavigate } from "react-router";

import GestionBusquedaContenido from "./../../../components/templates/GestionBusqueda/GestionBusquedaContenido";
import Titulo from "../../../components/atoms/titles/Titulo";
import Header from "../../../components/molecules/header/Header";
import Footer from "../../../components/molecules/footer/Footer";
const ErrorNoControlado = () => {
  const navigate = useNavigate();

  return (
    <>
      <Header></Header>
      <div className="container vh-100" role="main" data-landmark-index="4">
        <div className="caja-gestion-busqueda-acciones w-100">
          <Titulo tipo={"tituloModal"} titulo={"Error genérico"} />
          <GestionBusquedaContenido>
            <span className="text-center alert alert-warning">
              Error general en la aplicación, consulte con su administrador e
              informe de la siguiente fecha:
              <br />
              {getCurrentDateWithHour("/")}
            </span>

            <div className="botones-contenido-abajo d-flex justify-content-center">
              <button
                id="guardarAnexoii4"
                className="btnRed rounded m-2 w-25 py-2"
                type="button"
                onClick={() =>
                  navigate("/home")
                }
              >
                <i className="fa-solid fa-rotate-left"></i> Volver
              </button>
            </div>
          </GestionBusquedaContenido>
          <div className="caja_media accionesUsuario-scroll-list"></div>
        </div>
      </div>
      <Footer></Footer>
    </>
  );
};

export default ErrorNoControlado;
